// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RL1sA2tX1WQ1f9mQMzxD{gap:20px;display:flex;position:relative}.TKguPWlOx14G0giicggA{width:100%;max-width:492px}.G0_lRxPlGT4r4VTKWeg0{margin-bottom:16px}.ElD3RGthM_oj8nP6MT4K{background:var(--background-neutral-default);border-radius:6px;justify-content:center;align-items:center;height:24px;display:flex}.sh3oZ_mBA_c02j_WzZ2v{margin-right:2px}.PbnD5BzCkyc07jVwg0vT{margin-right:1px}.RsBhdGg8l2wJZYAApNIo{margin:0 8px}.ix7EM_Wz858gnjwTYyaF{display:block}.vcbu512KevEi3DFVfHYd{margin-top:4px;display:block}.vmzBC732MZMqxyttm2j6{flex-direction:column;gap:8px;display:flex}.nFI2rfnldrkuvLzKh4HR{gap:12px;height:44px;padding:0 12px}.eK3TsDbvY3szf90VdYLm{margin-left:-4px}.QktIN9WnUYolza0uIQ6y{margin-left:2px}.qntvLR7M4BAeAxPIL3z6{align-items:center;gap:4px;margin-left:-1px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RL1sA2tX1WQ1f9mQMzxD`,
	"questionBlock": `TKguPWlOx14G0giicggA`,
	"questionBlock__content": `G0_lRxPlGT4r4VTKWeg0`,
	"questionBlockContent": `G0_lRxPlGT4r4VTKWeg0`,
	"number": `ElD3RGthM_oj8nP6MT4K`,
	"leftIcon": `sh3oZ_mBA_c02j_WzZ2v`,
	"leftCaIcon": `PbnD5BzCkyc07jVwg0vT`,
	"plusBetweenFlags": `RsBhdGg8l2wJZYAApNIo`,
	"header": `ix7EM_Wz858gnjwTYyaF`,
	"headerDesc": `vcbu512KevEi3DFVfHYd`,
	"inputContainer": `vmzBC732MZMqxyttm2j6`,
	"inputRadio": `nFI2rfnldrkuvLzKh4HR`,
	"labelText": `eK3TsDbvY3szf90VdYLm`,
	"taxIdLabelText": `QktIN9WnUYolza0uIQ6y`,
	"customLabel": `qntvLR7M4BAeAxPIL3z6`
};
export default ___CSS_LOADER_EXPORT___;
